import React from 'react';
import Link from '@atlaskit/link';
import { Stack, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages';

export const FeedbackCollectorDescription = () => {
	const { formatMessage } = useIntl();

	return (
		<Stack xcss={feedbackCollectorDescriptionStyles}>
			{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
			<p>{formatMessage(messages.descriptionNonFinal)}</p>
			<p>
				{formatMessage(messages.learnMoreNonFinal, {
					link: (chunks: React.ReactNode[]) => <Link href="/">{chunks}</Link>,
				})}
			</p>
		</Stack>
	);
};

const feedbackCollectorDescriptionStyles = xcss({
	marginBottom: 'space.300',
});
